import { c as _c } from "react/compiler-runtime";
import { Image } from '@/app/components/media/image';
import { Blockquote } from '@/app/cv/components/sections/service/isuzu-care/testimonial-section/blockquote';
import { createDataAttributes } from '@/app/utils/createDataAttributes';
export interface IsuzuCareTestimonialItemProps {
  caption: string;
  author?: string;
  company?: string;
  image: string;
  index?: number;
}
export const IsuzuCareTestimonialCard = t0 => {
  const $ = _c(35);
  const {
    caption,
    author,
    company,
    image,
    index
  } = t0;
  const t1 = `item-card-${index}`;
  let t2;
  if ($[0] !== t1) {
    t2 = createDataAttributes({
      test: t1
    });
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = createDataAttributes({
      test: "contents"
    });
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  let t5;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = createDataAttributes({
      test: "contents-blockquote"
    });
    t5 = <Blockquote />;
    $[3] = t4;
    $[4] = t5;
  } else {
    t4 = $[3];
    t5 = $[4];
  }
  let t6;
  if ($[5] !== caption) {
    t6 = !!caption && <h3 className="text-h3 font-display where-span:text-inline-wrap" dangerouslySetInnerHTML={{
      __html: caption
    }} {...createDataAttributes({
      test: "description"
    })} />;
    $[5] = caption;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Blockquote className="ml-auto rotate-180" />;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== t6) {
    t8 = <div className="flex flex-col gap-y-2" {...t4}>{t5}{t6}{t7}</div>;
    $[8] = t6;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = createDataAttributes({
      test: "contents-author"
    });
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  const t10 = author ?? "";
  let t11;
  if ($[11] !== t10) {
    t11 = {
      __html: t10
    };
    $[11] = t10;
    $[12] = t11;
  } else {
    t11 = $[12];
  }
  let t12;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = createDataAttributes({
      test: "author"
    });
    $[13] = t12;
  } else {
    t12 = $[13];
  }
  let t13;
  if ($[14] !== t11) {
    t13 = <p className="text-body-1 font-noto-bold where-span:text-inline-wrap" dangerouslySetInnerHTML={t11} {...t12} />;
    $[14] = t11;
    $[15] = t13;
  } else {
    t13 = $[15];
  }
  const t14 = company ?? "";
  let t15;
  if ($[16] !== t14) {
    t15 = {
      __html: t14
    };
    $[16] = t14;
    $[17] = t15;
  } else {
    t15 = $[17];
  }
  let t16;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = createDataAttributes({
      test: "company"
    });
    $[18] = t16;
  } else {
    t16 = $[18];
  }
  let t17;
  if ($[19] !== t15) {
    t17 = <p className="text-body-2 text-gray-700" dangerouslySetInnerHTML={t15} {...t16} />;
    $[19] = t15;
    $[20] = t17;
  } else {
    t17 = $[20];
  }
  let t18;
  if ($[21] !== t13 || $[22] !== t17) {
    t18 = <div className="mt-4" {...t9}>{t13}{t17}</div>;
    $[21] = t13;
    $[22] = t17;
    $[23] = t18;
  } else {
    t18 = $[23];
  }
  let t19;
  if ($[24] !== t18 || $[25] !== t8) {
    t19 = <div className="flex flex-col justify-between gap-y-4" {...t3}>{t8}{t18}</div>;
    $[24] = t18;
    $[25] = t8;
    $[26] = t19;
  } else {
    t19 = $[26];
  }
  let t20;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = createDataAttributes({
      test: "contents-image"
    });
    $[27] = t20;
  } else {
    t20 = $[27];
  }
  const t21 = author ?? "";
  let t22;
  if ($[28] !== image || $[29] !== t21) {
    t22 = <div className="relative aspect-square w-full shrink-0 overflow-hidden rounded-sm lg:max-w-69" {...t20}><Image src={image} alt={t21} width={276} height={276} aspectRatio="aspect-1-1" layout="fill" sizes="(min-width: 1024px) 276px, 100vw" /></div>;
    $[28] = image;
    $[29] = t21;
    $[30] = t22;
  } else {
    t22 = $[30];
  }
  let t23;
  if ($[31] !== t19 || $[32] !== t2 || $[33] !== t22) {
    t23 = <div className="bg-silver-50 flex w-full flex-col gap-4 rounded-lg p-4 lg:flex-row lg:gap-12 lg:p-12" {...t2}>{t19}{t22}</div>;
    $[31] = t19;
    $[32] = t2;
    $[33] = t22;
    $[34] = t23;
  } else {
    t23 = $[34];
  }
  return t23;
};